import { yupResolver } from "@hookform/resolvers/yup"
import React, { useState, useEffect } from "react"
import { FormProvider, useForm } from "react-hook-form"
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormFeedback,
  Spinner,
  Form,
  FormGroup,
  Label,
} from "reactstrap"
import * as yup from "yup"
import LoadingButton from "../../components/Common/LoadingButton"
import { UFInput } from "../../components/Common/Fields/Input"
import classnames from "classnames"
import closeIcon from "../../assets/icons/close.svg"
import { postUser } from "../../services/Inventory/inventory"
import { toastError, toastSuccess } from "../../helpers/msg_helper"
import RoleLists from "../../components/Common/chooseFields/rolesLists"

const schema = yup.object().shape({
  // Name/email are required for user add/edit (not for the change-password modal).
  name: yup.string().when("$needsIdentity", {
    is: true,
    then: s => s.required("Name is Required"),
  }),
  email: yup.string().email("Enter a valid email").when("$needsIdentity", {
    is: true,
    then: s => s.required("Email is Required"),
  }),
  role: yup.mixed().required("Role is Required"),
  password: yup.string().when("$isAdd", {
    is: true,
    then: s => s.required("Password is Required").min(6, "Min 6 characters"),
  }),
  confirm_password: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords must Match"),
})

const Edit = ({
  loading,
  onUpdate,
  id,
  error,
  fromProfile,
  close,
  ...props
}) => {
  const isAdd = !props?.editItem?.value?.id
  const validationContext = { needsIdentity: !fromProfile, isAdd }
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
    context: validationContext,
  })
  const methods = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldFocusError: true,
    context: validationContext,
  })
  const [isLoading, setIsLoading] = useState(false)
  console.log(`fromProfile`, fromProfile, props)

  useEffect(() => {
    if (props?.editItem?.modal) {
      reset({
        id: props?.editItem?.value?.id,
        name: props?.editItem?.value?.name || "",
        email: props?.editItem?.value?.email || "",
        role: props?.editItem?.value?.roles?.[0]
          ? {
              label: props?.editItem?.value?.roles?.[0]?.name,
              value: props?.editItem?.value?.roles?.[0]?.id,
            }
          : undefined,
      })
    }
  }, [props?.editItem?.modal])

  const handleUserAdd = async data => {
    console.log(`data`, data)
    try {
      setIsLoading(true)
      const createdUser = await postUser({
        ...data,
        role: data?.role?.value,
        ...(data?.password !== "" && { password: data?.password }),
        ...(data?.confirm_password !== "" && {
          confirm_password: data?.confirm_password,
        }),
      })
      toastSuccess(createdUser?.message)
      {
        !fromProfile && onUpdate()
      }
    } catch (err) {
      toastError(err?.message)
    } finally {
      setIsLoading(false)
      reset()
      close()
    }
  }

  return (
    <>
      <ModalHeader className="custom-modal-header">
        <div className="d-flex justify-content-between">
          <h5>
            {fromProfile
              ? "Change Password"
              : isAdd
              ? "Add User"
              : "Edit User"}
          </h5>{" "}
          <img
            src={closeIcon}
            alt=""
            onClick={close}
            width="10"
            role="button"
          />
        </div>
      </ModalHeader>
      {loading ? (
        <div
          className="px-8"
          style={{
            width: "100%",
            textAlign: "center",
            minHeight: "200px",
            paddingTop: "90px",
          }}
        >
          <Spinner
            className={classnames({
              "mx-2": true,
              "position-relative": true,
              visible: true,
            })}
            size="lg"
          />
        </div>
      ) : (
        <>
          <ModalBody>
            <FormProvider {...methods}>
              <Form id={`ev-form`} onSubmit={handleSubmit(handleUserAdd)}>
                {!fromProfile ? (
                  <Row>
                    <Col sm={12}>
                      <FormGroup className="mb-4">
                        <Label>
                          Name<span className="mandatory">*</span>
                        </Label>
                        <UFInput
                          control={control}
                          placeholder="Enter the Name"
                          name={"name"}
                          invalid={!!errors.name}
                          type={"text"}
                        />
                        <FormFeedback invalid>{errors.name?.message}</FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col sm={12}>
                      <FormGroup className="mb-4">
                        <Label>
                          Email<span className="mandatory">*</span>
                        </Label>
                        <UFInput
                          control={control}
                          placeholder="Enter the Email"
                          name={"email"}
                          invalid={!!errors.email}
                          type={"email"}
                        />
                        <FormFeedback invalid>{errors.email?.message}</FormFeedback>
                      </FormGroup>
                    </Col>
                  </Row>
                ) : (
                  <></>
                )}

                <Row>
                  {!fromProfile ? (
                    <Col sm={12}>
                      <FormGroup className="mb-4">
                        <Label>
                          Role<span className="mandatory">*</span>
                        </Label>
                        <RoleLists
                          control={control}
                          placeholder="Select the Role"
                          name={"role"}
                        />
                        <FormFeedback invalid>
                          {errors.role?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                  ) : (
                    <></>
                  )}
                  <Col sm={12}>
                    <FormGroup className="mb-4">
                      <Label>Password</Label>
                      <UFInput
                        control={control}
                        placeholder="Enter the Password"
                        name={"password"}
                        invalid={!!errors.password}
                        type={"password"}
                      />
                      <FormFeedback invalid>
                        {errors.password?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col sm={12}>
                    <FormGroup className="mb-4">
                      <Label>Confirm Password</Label>
                      <UFInput
                        control={control}
                        placeholder="Enter the Confirm Password"
                        name={"confirm_password"}
                        invalid={!!errors.confirm_password}
                        type={"password"}
                      />
                      <FormFeedback invalid>
                        {errors.confirm_password?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                </Row>
              </Form>
            </FormProvider>
          </ModalBody>
          <ModalFooter>
            <LoadingButton
              form={`ev-form`}
              color={"primary"}
              loading={isLoading}
              disabled={isLoading}
              type="submit"
            >
              {props?.editItem?.modal ? "Update" : "Save"}
            </LoadingButton>
          </ModalFooter>
        </>
      )}
    </>
  )
}

const EditUser = ({ buttonLabel, className, fromProfile, ...props }) => {
  const [modal, setModal] = useState(false)
  const toggle = () => setModal(!modal)

  useEffect(() => {
    if (props?.editItem?.modal) {
      toggle()
    }
  }, [props?.editItem?.modal])
  console.log("props?.editItem :", fromProfile, props?.editItem)
  return (
    <>
      <button
        type="button"
        className={className}
        onClick={toggle}
        dangerouslySetInnerHTML={{ __html: buttonLabel }}
      />
      <Modal isOpen={modal} toggle={toggle} backdrop={"static"}>
        {console.log(`fromprooo`, fromProfile)}
        <Edit
          close={() => {
            setModal(false)
            props?.onReset()
          }}
          fromProfile={fromProfile}
          {...props}
        />
      </Modal>
    </>
  )
}

export default EditUser
